import React from "react";
import { motion } from "framer-motion";
import { MdClose } from "react-icons/md";
import Backdrop from "../common/Backdrop";
import logo from "../../assets/logoColor.webp";
import { videoModalAnim } from "../../Animation/Animation";

const VideoModal = ({ showVideoModal, setShowVideoModal }) => {
  return (
    <Backdrop onClick={() => setShowVideoModal({ project: false, video_url: "" })}>
      <motion.div
        variants={videoModalAnim}
        initial="hidden"
        animate="show"
        exit="exit"
        onClick={(e) => e.stopPropagation()}
        className="mx-4 my-auto w-11/12 md:w-8/12 lg:w-1/2 md:m-auto z-50 p-3 md:p-4 bg-white-900 text-center rounded-lg"
      >
        <div className="flex justify-between mb-4">
          <div className="w-20">
            <img src={logo} alt="thrill logo" />
          </div>
          <MdClose
            onClick={() => setShowVideoModal({ project: false, video_url: "" })}
            size={35}
            className="cursor-pointer"
          />
        </div>
        {showVideoModal?.video_url.includes("https://www.youtube.com") ? (
          <div className="h-72 md:h-96">
            <iframe
              className="overflow-hidden w-full h-full rounded-t-xl"
              src={`${showVideoModal?.video_url}?autoplay=1&mute=1`}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              donotallowfullscreen="true"
            ></iframe>
          </div>
        ) : (
          <div className="h-auto">
            <video
              preload="auto"
              src={showVideoModal.video_url}
              playsInline
              controls
              muted
              autoPlay
              loop
              className="h-full w-full object-contain rounded-lg"
            ></video>
          </div>
        )}
      </motion.div>
    </Backdrop>
  );
};

export default VideoModal;
